'use client';

import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from 'cn';
import { useTranslations } from 'use-intl';

import { ProjectResponseSendComponentProps } from '@/shared-project-response-message-renderers';

import { CONVERSATION_OVER_REVIEW_LABEL } from './project-response-handler.helpers';

export default function ConversationOverMessageFormRenderer({
  onClick,
  conversationOverText,
  showIcon,
  className,
}: Omit<ProjectResponseSendComponentProps, 'onSubmit'> & {
  onClick: () => void;
  showIcon?: boolean;
  className?: string;
}) {
  const t = useTranslations('Completion');

  const label =
    conversationOverText === CONVERSATION_OVER_REVIEW_LABEL
      ? t('leaveAReview')
      : (conversationOverText ?? t('done'));

  return (
    <button
      onClick={onClick}
      data-test='conversation-over-button'
      className={cn(
        className,
        'flex h-10 w-full flex-1 items-center justify-center rounded-full bg-linear-to-b from-gray-800 to-gray-900 px-3 py-2 text-xs font-medium text-white sm:h-8 sm:rounded-lg'
      )}
    >
      {showIcon && (
        <FontAwesomeIcon icon={faCheckCircle} className='mr-2' size='lg' />
      )}
      {label}
    </button>
  );
}
